import React, { FC } from 'react';

import { useParams } from 'react-router-dom';

import useFeatureFlags from 'api/useFeatureFlags';
import { EFeatureFlag, EProgressBarType } from 'constants/enums';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import { useFormFieldsContext } from '../../../context';
import { FormFieldsIdentitySection, FormFieldsSection } from '../components';

import {
  ClassicProgressBarFields,
  MilestoneProgressBarFields
} from './components';
import {
  findProgressBarTypeOption,
  PROGRESS_BAR_TYPE_OPTIONS,
  PROGRESS_BAR_TYPE_TOOLTIP
} from './ProgressBarFormFields.consts';

export const ProgressBarFormFields: FC = (): React.ReactElement => {
  const { values, setFieldValue } = useFormFieldsContext();
  const { publisherId } = useParams();
  const { getFeatureFlagByKey } = useFeatureFlags({ publisherId });

  const isMilestonesEnabled = Boolean(
    getFeatureFlagByKey(EFeatureFlag.REWARD_PROGRESS_BAR_MILESTONES_ENABLED)
  );

  const progressBarType = values.progressBarType || EProgressBarType.CLASSIC;
  const isMilestone =
    isMilestonesEnabled && progressBarType === EProgressBarType.MILESTONE;

  return (
    <React.Fragment>
      <FormFieldsSection
        heading="Progress Bar"
        description="Customize the progress bar to fit your store theme."
      >
        {isMilestonesEnabled && (
          <div className="mb-5">
            <InputSelectDropdown
              label="Progress Bar Type"
              infoTooltipContent={PROGRESS_BAR_TYPE_TOOLTIP}
              isRequired
              options={PROGRESS_BAR_TYPE_OPTIONS}
              defaultSelected={findProgressBarTypeOption(values.progressBarType)}
              onOptionChange={(value) =>
                setFieldValue('progressBarType', value as EProgressBarType)
              }
              buttonDataTestId="offer-design-progress-bar-type-button"
              listDataTestId="offer-design-progress-bar-type-list"
            />
          </div>
        )}
        <FormFieldsIdentitySection spacing="none" />
      </FormFieldsSection>

      {isMilestone ? (
        <MilestoneProgressBarFields />
      ) : (
        <ClassicProgressBarFields />
      )}
    </React.Fragment>
  );
};
